// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3R8Tx","title":"FrontImage_title__2cIv-"};